<template>
  <div>
    <b-row>
      <b-form-group
        v-if="degrees != null"
        id="input-group-module"
        :label="$t('parametrics.moduleDegree')"
        label-align="left"
        class="col-md-6"
        label-cols-sm="auto"
        content-cols-sm
      >
        <v-select
          :options="degrees"
          :placeholder="$t('training-add.chooseAModule')"
          label="title"
          v-model="selectedDegree"
          clearable
          @input="getDegreeModuleIds"
        >
          <template #no-options="{}">
            {{ $t("training-add.noOptions") }}
          </template>
        </v-select>
      </b-form-group>

      <b-form-group
        v-if="modules != null"
        id="input-group-module"
        :label="$t('training-add.module')"
        label-align="left"
        class="col-md-6"
        label-cols-sm="auto"
        content-cols-sm
      >
        <v-select
          :options="modules"
          :placeholder="$t('training-add.chooseAModule')"
          clearable
          label="title"
          v-model="selectedModule"
          @input="moduleSelected"
        >
          <template #no-options="{}">
            {{ $t("training-add.noOptions") }}
          </template>
        </v-select>
      </b-form-group>

      <b-form-group
        id="training-status"
        :label="$t('trainings.status')"
        label-for="input-training-status"
        label-align="left"
        label-cols-sm="auto"
        content-cols-sm
        class="col-lg-4"
        v-if="this.filters.status"
      >
        <b-form-select
          v-model="criteria.status"
          :options="statuses"
        />
        
      </b-form-group>
      <b-form-group
        id="training-from-date"
        :label="$t('trainings.startDate')"
        label-for="from-date"
        label-align="left"
        class="col-md-3"
        label-cols-sm="auto"
        content-cols-sm
        v-if="this.filters.date"
      >
        <b-form-datepicker
          id="from-date"
          v-model="criteria.periodStartDate"
          :placeholder="$t('trainings.date')"
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          locale="en-GB"
          reset-button
          :label-reset-button="$t('trainings.reset')"
        />
      </b-form-group>

      <b-form-group
        id="training-to-date"
        :label="$t('trainings.endDate')"
        label-for="to-date"
        label-align="left"
        class="col-md-3"
        label-cols-sm="auto"
        content-cols-sm
        v-if="this.filters.date"
      >
        <b-form-datepicker
          id="to-date"
          v-model="criteria.periodEndDate"
          :placeholder="$t('trainings.date')"
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          locale="en-GB"
          reset-button
          :label-reset-button="$t('trainings.reset')"
          :min="criteria.startDate"
        />
      </b-form-group>
      <b-input-group
        id="fieldset-horizontal"
        class="col-md-6"
        label-cols-sm="auto"
        content-cols-sm
        v-if="this.filters.search"
      >
        <b-input
          id="search-input"
          v-model="searchText"
          type="search"
          :placeholder="$t('trainings.searchByDescOrSurname')"
          debounce="500"
          @keyup.enter="criteriaChanged"
        />
      </b-input-group>
      <b-button
        class="ml-auto mr-3 esep-blue-bg"
        variant="primary"
        @click="criteriaChanged"
      >
        {{ $t("trainings.search") }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
import trainingService from "@/services/training.service";
import { handleApiError } from "@/services/error.service";

export default {
  props: {
    filters: {
      type: Object,
      default: function () {
        return {
          status: true,
          date: true,
          search: true,
        };
      },
    },
  },
  watch: {
    searchText: function (val) {
      this.criteria.search = val;
    },
  },
  computed: {
    isAdmin() {
      let isAdmin = false;
      let userInfo = this.$store.state.userInfo;
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (
          userInfo.roles[i].name == "ADMIN" ||
          userInfo.roles[i].name == "TRAINING_ADMIN"
        ) {
          isAdmin = true;
        }
      }
      return isAdmin;
    },
    isMod() {
      let isMod = false;
      let userInfo = this.$store.state.userInfo;
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (userInfo.roles[i].name == "TRAIN_MOD") {
          isMod = true;
        }
      }
      return isMod;
    },
    isTrainer() {
      let isTrainer = false;
      let userInfo = this.$store.state.userInfo;
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (userInfo.roles[i].name == "TRAINER") {
          isTrainer = true;
        }
      }
      return isTrainer;
    },
    statuses() {
      let statuses = null;
      if (this.isAdmin) {
        statuses = [
          { value: null, text: this.$t("trainingStatusEnums.null") },
          { value: "PROPOSED", text: this.$t("trainingStatusEnums.PROPOSED") },
          { value: "SCHEDULED", text: this.$t("trainingStatusEnums.SCHEDULED") },
          { value: "REJECTED", text: this.$t("trainingStatusEnums.REJECTED") },
          {
            value: "TO_BE_SUBMITTED",
            text: this.$t("trainingStatusEnums.TO_BE_SUBMITTED"),
          },
          {
            value: "PENDING_APPROVAL",
            text: this.$t("trainingStatusEnums.PENDING_APPROVAL"),
          },
          { value: "APPROVED", text: this.$t("trainingStatusEnums.APPROVED") },
          { value: "CANCELLED", text: this.$t("trainingStatusEnums.CANCELLED") },
          {
            value: "TO_BE_COMPLETED",
            text: this.$t("trainingStatusEnums.TO_BE_COMPLETED"),
          },
          { value: "COMPLETED", text: this.$t("trainingStatusEnums.COMPLETED") },
        ];
      } else if (this.isMod && !this.isTrainer) {
        statuses = [
          { value: "PROPOSED", text: this.$t("trainingStatusEnums.PROPOSED") },
          { value: "REJECTED", text: this.$t("trainingStatusEnums.REJECTED") },
          { value: "SCHEDULED", text: this.$t("trainingStatusEnums.SCHEDULED") },
        ];
      } else {
        statuses = [
          { value: "PROPOSED", text: this.$t("trainingStatusEnums.PROPOSED") },
          { value: "SCHEDULED", text: this.$t("trainingStatusEnums.SCHEDULED") },
          { value: "REJECTED", text: this.$t("trainingStatusEnums.REJECTED") },
          {
            value: "TO_BE_SUBMITTED",
            text: this.$t("trainingStatusEnums.TO_BE_SUBMITTED"),
          },
          {
            value: "PENDING_APPROVAL",
            text: this.$t("trainingStatusEnums.PENDING_APPROVAL"),
          },
          { value: "APPROVED", text: this.$t("trainingStatusEnums.APPROVED") },
          {
            value: "TO_BE_COMPLETED",
            text: this.$t("trainingStatusEnums.TO_BE_COMPLETED"),
          },
        ];
      }
      return statuses;
    },
  },
  mounted() {
    if (this.$store.state.latestActivityStatus) {
      this.criteria.status = this.$store.state.latestActivityStatus;
    }
    if (this.filters.modules) {
      this.getAllModules();
      this.getAllDegrees();
    }
  },
  data() {
    return {
      criteria: {
        status: "SCHEDULED",
        periodStartDate: null,
        periodEndDate: null,
        search: null,
      },
      selectedModule: null,
      selectedDegree: null,
      modules: null,
      degrees: null,
      selectedModuleIds: null,
      degreePrerequisites: null,
      searchText: null,
    };
  },
  methods: {
    criteriaChanged() {
      this.$store.state.latestActivityStatus = this.criteria.status;
      this.$emit("refresh-list", this.criteria);
    },
    getAllModules() {
      trainingService.getModulesByCriteria(true, null, false).then(
        (response) => {
          this.modules = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
        }
      );
    },
    getAllDegrees() {
      trainingService.getModulesByCriteria(true, null, true).then(
        (response) => {
          this.degrees = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
        }
      );
    },
    moduleSelected() {
      if (this.selectedModule) {
        this.selectedModuleIds = [this.selectedModule?.id];
      } else if (this.selectedDegree) {
        this.selectedModuleIds = this.modules.map((a) => {
          return a.id;
        });
      } else {
        this.selectedModuleIds = null;
      }
      this.criteria.moduleIds = this.selectedModuleIds;
      this.$emit("refresh-list", this.criteria);
    },
    getDegreeModuleIds() {
      this.selectedModule = null;
      if (!this.selectedDegree) {
        this.selectedModuleIds = [];
        this.criteria.moduleIds = [];
        this.$emit("refresh-list", this.criteria);
        this.getAllModules();
        return;
      }
      trainingService.getModuleDependencies(this.selectedDegree.id).then(
        (response) => {
          this.selectedModuleIds = response.data.map((a) => {
            return a.prerequisiteModule.id;
          });
          this.modules = response.data.map((a) => {
            return a.prerequisiteModule;
          });
          this.criteria.moduleIds = this.selectedModuleIds;
          this.$emit("refresh-list", this.criteria);
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      );
    },
  },
};
</script>
